module.exports = __webpack_public_path__ + "img/sync.ace29053.svg";